export default class IconListModel {
  static iconList = [
    'line-alarm',
    'line-alert',
    'line-app-notification',
    'line-block',
    'line-bookmark',
    'line-bug',
    'line-check-double',
    'line-check',
    'line-cloud-disable',
    'line-cloud-download',
    'line-cloud-upload',
    'line-cloud',
    'line-cogwheel',
    'line-copy',
    'line-cross',
    'line-cut',
    'line-dashboard',
    'line-down',
    'line-download-queue',
    'line-download',
    'line-draft',
    'line-exit-fullscreen',
    'line-eye-close',
    'line-eye-open',
    'line-female-user',
    'line-file',
    'line-filter',
    'line-flag',
    'line-fullscreen',
    'line-heart',
    'line-help',
    'line-home',
    'line-information',
    'line-left',
    'line-lifebuoy',
    'line-list',
    'line-loading',
    'line-lock',
    'line-login',
    'line-logout',
    'line-menu-burger',
    'line-menu-dots',
    'line-microphone-disable',
    'line-microphone',
    'line-minus',
    'line-note',
    'line-notification-disable',
    'line-notification',
    'line-paste',
    'line-plus',
    'line-power-sign',
    'line-print',
    'line-puzzle',
    'line-refresh',
    'line-reply-all',
    'line-reply',
    'line-right',
    'line-save',
    'line-screenshot',
    'line-search-check',
    'line-search-cross',
    'line-search-minus',
    'line-search-plus',
    'line-search',
    'line-share',
    'line-shield',
    'line-snooze',
    'line-star',
    'line-stars',
    'line-sync',
    'line-task',
    'line-time',
    'line-trash-empty',
    'line-trash-full',
    'line-trash',
    'line-umbrella',
    'line-unlock',
    'line-up',
    'line-upload-queue',
    'line-upload',
    'line-user',
    'line-verification-fail',
    'line-verification',
    'line-wrench',
    'line-write',
    'menu-kebab',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'alarm1',
    'alert1',
    'app-notification1',
    'block',
    'bookmark',
    'bug',
    'check-double',
    'check',
    'cloud-disable',
    'cloud-download',
    'cloud-upload',
    'cloud',
    'cogwheel',
    'copy',
    'cross',
    'cut',
    'dashboard',
    'down',
    'download-queue',
    'download',
    'draft',
    'exit-fullscreen',
    'eye-close',
    'eye-open',
    'female-user',
    'file',
    'filter',
    'flag',
    'fullscreen',
    'heart',
    'help',
    'home',
    'information',
    'left',
    'lifebuoy',
    'list',
    'loading',
    'lock',
    'login',
    'logout',
    'menu-burger',
    'menu-dots',
    'microphone-disable',
    'microphone',
    'minus',
    'note',
    'notification-disable',
    'notification',
    'paste',
    'plus',
    'power-sign',
    'print',
    'puzzle',
    'refresh',
    'reply-all',
    'reply',
    'right',
    'save',
    'screenshot',
    'search-alt',
    'search-check',
    'search-cross',
    'search-minus',
    'search-plus',
    'share',
    'shield',
    'snooze',
    'star',
    'stars',
    'sync',
    'task',
    'time',
    'trash-empty',
    'trash-full',
    'trash',
    'umbrella',
    'unlock',
    'up',
    'upload-queue',
    'upload',
    'user',
    'verification-fail',
    'verification',
    'wrench',
    'write'
  ]
}
